import {
  getContextualSegmentKey,
  parseCustomFormatToProviderSelections,
} from '@openx/components-targeting/Targeting/ContextualSegments/utils/enrichment';
import type { CustomVariablesDataPayload } from '@openx/types/targeting/customVariables';

type IncludedContextualSegments = {
  keys: Set<string>;
  providerIds: string[];
  segmentIds: string[];
};

export const getIncludedContextualSegments = (
  contextual: CustomVariablesDataPayload[] | null | undefined
): IncludedContextualSegments => {
  const selections = parseCustomFormatToProviderSelections(contextual ?? []).filter(
    ({ includes }) => includes.length > 0
  );
  const identities = selections.flatMap(({ providerId, includes }) =>
    includes.map(segmentId => ({ providerId, segmentId }))
  );

  return {
    keys: new Set(identities.map(getContextualSegmentKey)),
    providerIds: selections.map(({ providerId }) => providerId),
    segmentIds: Array.from(new Set(identities.map(({ segmentId }) => segmentId))),
  };
};
